var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpamAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.125A6.125 6.125 0 107 .875a6.125 6.125 0 000 12.25z",
    fill: "#F74F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49 8.02V3.939h1.02V8.02H6.49zM6.49 10.063V9.041h1.02v1.02H6.49z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/spam-alert-icon.c2bbbe49.svg";
export { SvgSpamAlertIcon as ReactComponent };